__webpack_require__.p = "/assets/shell/card/scripts/";